/** Señales de duplicidad / resucitado (tropicalizado, todas las verticales). */

export function phoneKey(phone) {
  const d = String(phone || '').replace(/\D/g, '');
  return d.length >= 10 ? d.slice(-10) : d;
}

export function markDuplicatesInList(leads) {
  const list = Array.isArray(leads) ? leads : [];
  const byPh = {};
  const byEm = {};
  for (const l of list) {
    const pk = phoneKey(l.phone);
    if (pk.length >= 10) (byPh[pk] ||= []).push(l);
    const em = String(l.email || '').trim().toLowerCase();
    if (em) (byEm[em] ||= []).push(l);
  }
  const familyOf = (l) => {
    const map = new Map();
    const pk = phoneKey(l.phone);
    for (const x of (byPh[pk] || [])) map.set(x.id, x);
    const em = String(l.email || '').trim().toLowerCase();
    for (const x of (byEm[em] || [])) map.set(x.id, x);
    return [...map.values()];
  };
  return list.map((l) => {
    const fam = familyOf(l);
    if (fam.length < 2) return l;
    const oldest = [...fam].sort((a, b) => String(a.created_at || '').localeCompare(String(b.created_at || '')))[0];
    return {
      ...l,
      is_duplicate: true,
      duplicate_family_size: fam.length,
      inquiry_count: Math.max(Number(l.inquiry_count || 0), fam.length),
      original_lead_id: l.original_lead_id || oldest?.id || l.id,
    };
  });
}

export function isDupLead(lead) {
  if (!lead) return false;
  if (lead.is_duplicate) return true;
  if (lead.is_resurrected) return true;
  if ((lead.inquiry_count || 0) >= 2) return true;
  if ((lead.duplicate_family_size || 0) >= 2) return true;
  if ((lead.original_lead_id || '') && lead.original_lead_id !== lead.id) return true;
  const level = lead.assignment_trace?.level || lead.assignment_level;
  return level === 'duplicate';
}

export function isResurrectedOpp(opp, lead) {
  if (opp?.is_resurrected || opp?.came_back_at) return true;
  if (lead?.is_resurrected) return true;
  return false;
}

export function frequencyOf(lead) {
  const n = Number(lead?.inquiry_count || lead?.frequency || lead?.duplicate_family_size || 0);
  return n > 0 ? n : (isDupLead(lead) ? 2 : 1);
}
